import React from 'react';
import Table from 'react-bootstrap/Table';
import HeadingRow from './HeadingRow';
import TableRow from './TableRow';
import ResultItemsActions from '../../../../Components/ResultItemsActions';

function CartDiamondsTable(props){
  const { cartDiamonds, onDelete, emptyCart } = props;

  return (
    <Table striped bordered hover size="sm" className="small border-0">
      <thead>
        <HeadingRow emptyCart={emptyCart}/>
      </thead>
      <tbody className="result-table-row result-table-row-closed">
        {Object.values(cartDiamonds).map((cartDiamond) =>
          <TableRow key={cartDiamond.id} cartDiamond={cartDiamond} onDelete={onDelete} />
        )}
      </tbody>
      <tbody>
        <tr className="result-items-actions-row">
          <td colSpan={21} className="sticky-bottom border border-dark bg-info">
            <ResultItemsActions
              selectedItems={cartDiamonds}
              emptyItems={emptyCart}
              showSave={false}
            />
          </td>
        </tr>
      </tbody>
    </Table>
  );
}

export default CartDiamondsTable;
